<template>
  <ContentDisplay
    data-testid="suggestion-card"
    class="suggestion-card"
    :blocks-length="2"
    footer-label="Ver Sugestão"
    @click="handleClick"
  >
    <template #content-block-1>
      <HeadingDisplay
        :title="suggestion.type.formatted"
        :subtitle="
          suggestion.portfolioName
            ? `Carteira &quot;${suggestion.portfolioName}&quot;`
            : undefined
        "
        size="extra-small"
      />
    </template>
    <template #content-block-2>
      <ListDisplay
        title="Sugerida em"
        :value="suggestion.createdAt.formatted"
      />
      <ListDisplay
        v-if="showExpireDate"
        title="Expira em"
        :value="suggestion.expiredAt.formatted"
      />
      <ListDisplay
        v-if="suggestion.amount.value"
        title="Valor total"
        :value="suggestion.amount.formatted"
      />
      <ListDisplay
        v-if="suggestion.quantity"
        title="Quantidade"
        :value="suggestion.quantity"
      />
    </template>
  </ContentDisplay>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import {
  ContentDisplay,
  HeadingDisplay,
  ListDisplay
} from '@warrenbrasil/nebraska-web';
import { IInvestmentSuggestion } from '@/modules/wealth/services/investment-suggestions';
@Component({
  components: {
    ContentDisplay,
    HeadingDisplay,
    ListDisplay
  }
})
export default class SugestionCard extends Vue {
  @Prop({ type: Object, required: true })
  public suggestion!: IInvestmentSuggestion;

  @Emit('suggestion-click')
  emitSuggestionClick() {
    return {
      transactionId: this.suggestion.transactionId,
      portfolioId: this.suggestion.portfolioApiId
    };
  }

  get showExpireDate() {
    const { expiredAt } = this.suggestion;
    return expiredAt && expiredAt.formatted && expiredAt.formatted !== '';
  }

  handleClick() {
    this.emitSuggestionClick();
  }
}
</script>

<style lang="less" scoped>
.suggestion-card {
  margin-bottom: @size-spacing-x400;
  max-width: 592px;
}
</style>
